import * as ActionTypes from "./actionTypes";

export function loadSessions(appKey) {
	return { type: ActionTypes.LOAD_SESSIONS, appKey };
}

export function loadSessionsSuccess(sessions) {
	let newSessions = [];
	for (let session of sessions) {
		let { id, hasParent, parentId } = session;
		if (hasParent) {
			// it has a parent
			// we need to get the parent session from either newSessions or sessions
			// - newSessions first, in case we've already found it
			// - sessions last, in case the parent is further down the list (we haven't looked at it yet)
			let potentialParentInNewSessions = newSessions.find(i => i.id === parentId);
			let potentialParentInOldSessions = sessions.find(i => i.id === parentId);
			let parentItem;
			if (potentialParentInNewSessions) {
				parentItem = potentialParentInNewSessions;
			} else {
				// check to see if the parent session even exists in the all sessions list
				// if it doesn't, just push the existing session to our new list and move onto the next session
				if (potentialParentInOldSessions) {
					parentItem = { ...potentialParentInOldSessions };
				} else {
					newSessions.push(session);
					continue;
				}
			}
			// push to the `childItems` array
			if ("childItems" in parentItem) {
				parentItem.childItems.push(session);
			} else {
				parentItem.childItems = [session];
			}
			// if we went down the path of not finding the parent in our newSessions array, push this new parent session to it
			if (!potentialParentInNewSessions) {
				newSessions.push(parentItem);
			}
		} else {
			// this session has no parent
			// we still need to see if this session was already added to the newSessions array though
			// if it wasn't, add it now
			let isInNewItems = newSessions.find(i => i.id === id);
			if (!isInNewItems) {
				newSessions.push(session);
			}
		}
	}

	return { type: ActionTypes.LOAD_SESSIONS_SUCCESS, sessions: newSessions };
}

export function loadSessionsFail(errorMessage) {
	return { type: ActionTypes.LOAD_SESSIONS_FAIL, errorMessage };
}

export function selectSession(session) {
	return { type: ActionTypes.SELECT_SESSION, session };
}

export function selectSessionSuccess(session) {
	return { type: ActionTypes.SELECT_SESSION_SUCCESS, session };
}

export function resetCurrentSession() {
	return { type: ActionTypes.RESET_CURRENT_SESSION };
}

export function selectSessionFailure(errorMessage) {
	return { type: ActionTypes.SELECT_SESSION_FAILURE, errorMessage };
}
